import { Component, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'vs-page-toggle',
  styleUrl: 'page-toggle.scss',
  shadow: false,
})
export class PageToggle {
  @Prop() data: string | Record<string, any>;

  private parsedData: Record<string, any> = {};

  @State() screenWidth = 0;

  componentWillLoad() {
    this.parsedData = typeof this.data === 'string' ? JSON.parse(this.data) : this.data;
    this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    window.addEventListener('resize', this.debounce(this.resizeEventHandler, 300));
  }

  private debounce(func: Function, wait: number) {
    let timeout: ReturnType<typeof setTimeout>;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  resizeEventHandler = () => {
    this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  };

  disconnectedCallback() {
    window.removeEventListener('resize', this.debounce(this.resizeEventHandler, 300));
  }

  private getLinkAttributes(isActive: boolean, title: string) {
    const attributes: { [key: string]: string } = {};
    attributes.href = isActive ? '#' : this.parsedData.ctaLink;
    attributes.target = attributes.href === '#' ? '_self' : (this.parsedData.linkTarget || '_self');
  
    if (attributes.target === '_blank') {
      attributes['aria-label'] = `${title} - ${this.parsedData.ariaLabelNewWindow}`;
    }
  
    return attributes;
  }

  render() {
    const baseClass = this.screenWidth > 1200 ? 'vs-text' : 'vs-text vs-meta';
    const containerClass = `vs-toggle-container vs-d-flex vs-justify-content-center vs-m-auto ${this.parsedData.backgroundColor}`;

    return (
      <nav 
        class={containerClass}
        aria-label={`${this.parsedData.toggleTitleLeft} | ${this.parsedData.toggleTitleRight}`}
      >
        <div class="vs-toggle-wrapper vs-d-inline-flex">
          <a
            class={`${baseClass} vs-toggle-btn${this.parsedData.toggleState === 'primary' ? ' active' : ''}`}
            {...this.getLinkAttributes(this.parsedData.toggleState === 'primary', this.parsedData.toggleTitleLeft)}
            aria-current={this.parsedData.toggleState === 'primary' ? 'page' : 'false'}
          >
            {this.parsedData.toggleTitleLeft || ''}
          </a>
          <a
            class={`${baseClass} vs-toggle-btn${this.parsedData.toggleState === 'secondary' ? ' active' : ''}`}
            {...this.getLinkAttributes(this.parsedData.toggleState === 'secondary', this.parsedData.toggleTitleRight)}
            aria-current={this.parsedData.toggleState === 'secondary' ? 'page' : 'false'}
          >
            {this.parsedData.toggleTitleRight || ''}
          </a>
        </div>
      </nav>
    );
  }
}